export default __webpack_public_path__ + "static/media/img--design-7.d805127e.jpg";